// extracted by css-extract-rspack-plugin
export default {"language":"language_xOcSM"};